// export const apiEndpoints = {
//   health: "/health",
//   auth: {
//     login: "/auth/login",
//     logout: "/auth/logout",
//     me: "/auth/me",
//   },
//   cameras: {
//     list: "/cameras",
//     detail: (id: string) => `/cameras/${id}`,
//   },
//   devices: {
//     list: "/api/Devices",
//   },
//   events: {
//     list: "/events",
//   },
// } as const;

export const apiEndpoints = {
  health: "/health",

  auth: {
    login: "/api/Auth/login",
    logout: "/api/Auth/logout",
    me: "/api/Auth/me",
  },

  cameras: {
    list: "/cameras",
    detail: (id: string) => `/cameras/${id}`,
  },

  devices: {
    list: "/api/Devices",
    detail: (imei: string) => `/api/Devices/${imei}`,
    update: (id: number) => `/api/Devices/${id}`,
    activate: (id: number) => `/api/Devices/${id}/activate`,
    snapshots: (imei: string) => `/api/devices/${imei}/snapshots`,
    position: (imei: string) => `/api/Devices/${imei}/position`,
    systemInfo: (imei: string) => `/api/devices/${imei}/system-info`,
  },

  realtime: {
    positions: "/api/realtime/positions",
  },

  viewSessions: {
    create: "/api/ViewSessions",
    ping: (sessionId: number) => `/api/ViewSessions/${sessionId}/ping`,
    stop: (sessionId: number) => `/api/ViewSessions/${sessionId}`,
  },

  recordings: {
    requestDays: (imei: string) => `/api/devices/${imei}/recordings/request-days`,
    days: (imei: string) => `/api/devices/${imei}/recordings/days`,
    requestTimeline: (imei: string) => `/api/devices/${imei}/recordings/request-timeline`,
    timeline: (imei: string) => `/api/devices/${imei}/recordings/timeline`,
  },

  users: {
    list: "/api/users",
    create: "/api/users",
    detail: (id: number) => `/api/users/${id}`,
    update: (id: number) => `/api/users/${id}`,
    remove: (id: number) => `/api/users/${id}`,
  },

  playback: {
    start: (imei: string) => `/api/devices/${imei}/playback`,
    session: (imei: string, cameraKey: string) => `/api/devices/${imei}/playback/${cameraKey}/session`,
    ack: (imei: string, cameraKey: string) => `/api/devices/${imei}/playback/${cameraKey}/ack`,
    ping: (imei: string, sessionId: number) => `/api/devices/${imei}/playback/${sessionId}/ping`,
    stop: (imei: string, sessionId: number, cameraKey?: string) =>
      cameraKey ? `/api/devices/${imei}/playback/${sessionId}?cameraKey=${cameraKey}` : `/api/devices/${imei}/playback/${sessionId}`,
  },

  permissionGroups: {
    list: "/api/permission-groups",
    create: "/api/permission-groups",
    detail: (id: number) => `/api/permission-groups/${id}`,
    update: (id: number) => `/api/permission-groups/${id}`,
    remove: (id: number) => `/api/permission-groups/${id}`,
  },

  events: {
    list: "/events",
  },
} as const;